/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'app.bsky.feed.describeFeedGenerator'

type $nsid = typeof $nsid

export { $nsid }

type Feed = {
  $type?: 'app.bsky.feed.describeFeedGenerator#feed'
  uri: l.AtUriString
}

export type { Feed }

const feed = /*#__PURE__*/ l.typedObject<Feed>(
  $nsid,
  'feed',
  /*#__PURE__*/ l.object({ uri: /*#__PURE__*/ l.string({ format: 'at-uri' }) }),
)

export { feed }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  did: /*#__PURE__*/ l.string({ format: 'did' }),
  feeds: /*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Feed>((() => feed) as any)),
  links: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<Links>((() => links) as any),
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Get information about a feed generator, including policies and offered feed URIs. Does not require auth; implemented by Feed Generator services (not App View). */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type Links = {
  $type?: 'app.bsky.feed.describeFeedGenerator#links'
  privacyPolicy?: string
  termsOfService?: string
}

export type { Links }

const links = /*#__PURE__*/ l.typedObject<Links>(
  $nsid,
  'links',
  /*#__PURE__*/ l.object({
    privacyPolicy: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    termsOfService: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { links }
